import { gql } from '@apollo/client'

export const userHashtagFolderRemoveById = gql`
  mutation UserHashtagFolderRemoveById($_id: String!) {
    userHashtagFolderRemoveById(_id: $_id)
  }
`
